import type { PresetPlacement } from '../../gql';

import { mockPlacement } from './mockPlacement';
import { mockPresetMaterial } from './mockPresetMaterial';

const mockPresetPlacement = (
    overwrite?: Partial<PresetPlacement>
): PresetPlacement => ({
    placement: mockPlacement(),
    presetMaterial: mockPresetMaterial(),
    ...overwrite,
});

export { mockPresetPlacement };
